import React, { useState, useEffect } from "react";
import * as pb from "../generated/catalog_pb";
import { catalogClient } from "../services/grpc";
import { Button } from "../comp/ui/button";
import { ChevronDown, ChevronUp } from "lucide-react";
import { Empty } from "google-protobuf/google/protobuf/empty_pb";

interface Mark {
  name: string;
}

interface MarkSelectorProps {
  selectedMark: string;
  onMarkSelect: (mark: string) => void;
}

export function MarkSelector({ selectedMark, onMarkSelect }: MarkSelectorProps) {
  const MarkList=["ANKAI","Golden Dragon","HIGER","JAC","KING LONG","SHENLONG"];
  const [marks, setMarks] = useState<Mark[]>([]);
  const [loading, setLoading] = useState(true);
  const [expanded, setExpanded] = useState(false);

  const itemsPerRow = 8;

  useEffect(() => {
    fetchMarks();
  }, []);

  const fetchMarks = async () => {
    try {
 const req = new pb.AutoReq();
req.setName("YUTONG");

   const response = await new Promise<pb.AutoRes>((resolve, reject) => {
   catalogClient.autoRequest(req, {}, (err, res) => {
    if (err) reject(err);
      else resolve(res);
    });
   });

const autos = response.getListList().map((item) => ({
  name: item.getName(),
}));
setMarks(autos);
    } catch (error) {
      console.error("Error loading marks:", error);
    } finally {
      setLoading(false);
    }
  };

  const visibleMarks = expanded ? marks : marks.slice(0, itemsPerRow);
  const hasMore = marks.length > itemsPerRow;

  if (loading) {
    return (
      <div className="flex flex-wrap gap-2 mb-4">
        {[...Array(8)].map((_, i) => (
          <div key={i} className="h-9 w-24 bg-gray-100 animate-pulse rounded-full" />
        ))}
      </div>
    );
  }

  return (
    <div className="mb-6">
      <h3 className="text-lg font-semibold text-blue-900 mb-3">Марка</h3>

      <div className="flex flex-wrap gap-2">
        {/* Mark buttons */}
        {visibleMarks.map((mark) => (
          <Button
            key={mark.name}
            variant={selectedMark === mark.name ? "default" : "outline"}
            size="sm"
            className={`rounded-full px-4 ${
              selectedMark === mark.name
                ? "bg-blue-600 hover:bg-blue-700 text-white"
                : "hover:bg-blue-50"
            }`}
            onClick={() => onMarkSelect(mark.name)}
          >
            {mark.name}
          </Button>
        ))}

        {/* Expand / Collapse */}
        {hasMore && (
          <Button
            variant="ghost"
            size="sm"
            className="text-blue-600 hover:text-blue-700 hover:bg-blue-50 rounded-full"
            onClick={() => setExpanded(!expanded)}
          >
            {expanded ? (
              <>
                Свернуть <ChevronUp className="ml-1 w-4 h-4" />
              </>
            ) : (
              <>
                Ещё ({marks.length - itemsPerRow}) <ChevronDown className="ml-1 w-4 h-4" />
              </>
            )}
          </Button>
        )}
      </div>
    </div>
  );
}